export const LocalStorageKeys = {
  DISCOUNT_CODE: 'discount-code',
  FAVORITES: 'favorites',
  FAVORITE_TIME: 'favorites-updated-time',
  LAST_SEEN_SET_DISCOUNT: 'last-seen-set-discount',
  HOME_PAGE_ID: 'home-page-id',
  BANNER_CONDITION: 'banner-condition',
  SEARCH_PRODUCT_CLICK: 'search-product-click',
  MOBILE_SUBCATEGORY_MENU: 'mobile-subcategory-menu',
  ROOM_IDEAS_WIDGET_STATE: 'room-ideas-widget-state',
  SITE_WIDE_MESSAGES: 'seen-site-wide-messages',
  CROSS_SELL_ON_CART: 'cross-sell-on-cart',
  NEW_NAVIGATION: 'new-navigation',
  QUOTE_ID: 'quote-id',
  DEVICE_FINGERPRINT: 'device-fingerprint',
  ALCHEMIST_ID: 'alchemist-id',
  ALCHEMIST_SESSION: 'alchemist-session',
  ALCHEMIST_EVENTS: 'alchemist-events',
  BROWSE_ROOM_PAGE: 'browse-room-page',
  LIMITED_IMAGE_TAGGING: 'limited-image-tagging',
  CROSS_SELL_PDP: 'cross-sell-pdp',
  SOFA_FINDER_VARIANT_STATUS_TRACKED: 'sofa-finder-variant-status-tracked',
  AB_TESTS: 'ab-tests'
};

export default class LocalStorage {
  static get storage() {
    if (typeof window !== 'undefined' && 'localStorage' in window) {
      return window.localStorage;
    }

    return {
      getItem() {},
      setItem() {},
      removeItem() {},
    };
  }

  static get(key) {
    try {
      return this.storage.getItem(key);
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  static set(key, value) {
    try {
      this.storage.setItem(key, value);
    } catch (e) {
      console.error(e);
    }
  }

  static remove(key) {
    try {
      this.storage.removeItem(key);
    } catch (e) {
      console.error(e);
    }
  }
}
